// src/pages/Admin/RoleComponents/RoleTable.jsx
import React from "react";
import { Button, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import StatusTag from "./StatusTag"; // You might need to adjust the import path
import GenericMUITable from "../../../../components/GenericTable"; // You might need to adjust the import path

const RoleTable = ({
  roles,
  handleEditRoleClick,
  handleManagePermissionsClick,
  formatDateTime,
  currentPage,
  totalPages,
  totalRecords,
  itemsPerPage,
  handlePageChange,
  handleItemsPerPageChange,
}) => {
  console.log(roles);
  const roleFields = [
    { key: "name", label: "Name" },
    { key: "description", label: "Description" },
    { key: "type", label: "Type" },
    { key: "applicableOn", label: "Applicable On" },
    {
      key: "status",
      label: "Status",
      render: (role) => <StatusTag status={role.status} />,
    },
    {
      key: "createdAt",
      label: "Created At",
      render: (role) => formatDateTime(role.createdAt),
    },
    {
      key: "actions",
      label: "Actions",
      render: (role) => {
        console.log(role, "button role");
        return (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Button
              size="small"
              onClick={() => handleEditRoleClick(role)}
              aria-label={`Edit ${role.name}`}
              sx={{ minWidth: "auto", p: "4px" }}
            >
              <EditIcon sx={{ color: "#828282" }} />
            </Button>
            <Button
              size="small"
              onClick={() => handleManagePermissionsClick(role.name)}
              aria-label={`Manage permissions for ${role.name}`}
              sx={{ minWidth: "auto", p: "4px" }}
            >
              <VisibilityIcon sx={{ color: "#828282" }} />
            </Button>
          </Box>
        );
      },
    },
  ];

  return (
    <GenericMUITable
      fields={roleFields}
      data={roles}
      rowKey="id"
      pagination={{
        currentPage,
        totalPages,
        totalRecords,
        itemsPerPage,
        onPageChange: handlePageChange,
        onItemsPerPageChange: handleItemsPerPageChange,
      }}
    />
  );
};

export default RoleTable;
